export const getPrice = (sum: number): string => {
  const roundSum = Math.round(sum * 100) / 100;
  return roundSum.toLocaleString('us-US', {
    style: 'currency',
    currency: 'USD',
  });
};
